import { render, staticRenderFns } from "./BpmnViewer.vue?vue&type=template&id=070d678c"
import script from "./BpmnViewer.vue?vue&type=script&lang=js"
export * from "./BpmnViewer.vue?vue&type=script&lang=js"
import style0 from "./BpmnViewer.vue?vue&type=style&index=0&id=070d678c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports